import { useEffect, useState } from "react";
import axios from "axios";
import { PawPrint } from "lucide-react";
import { Tel } from "@/components/emergency/parts";

function Photo({ url, session, alt }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let u = null;
    axios.get(url, { headers: { "X-Sitter-Session": session }, responseType: "blob" }).then(({ data }) => { u = URL.createObjectURL(data); setSrc(u); }).catch(() => {});
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [url, session]);
  return <span className="flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-q-raised">{src ? <img src={src} alt={alt} className="h-full w-full object-cover" /> : <PawPrint className="h-8 w-8 text-q-muted" />}</span>;
}

function Check({ label, done, canFeed, verb, onTap, testid }) {
  return (
    <li className="flex min-h-[44px] flex-wrap items-center gap-2 text-sm" data-testid={testid}>
      <span className="min-w-0 flex-1">{label}{done && <span className="block text-xs text-q-muted" data-testid={`${testid}-done`}>{done.label}</span>}</span>
      {canFeed && <button className={`q-btn min-h-[44px] ${done ? "q-btn-ghost" : "q-btn-primary"}`} onClick={onTap} data-testid={`${testid}-btn`}>{verb}</button>}
    </li>
  );
}

export function GuestPets({ api, session, d, reload }) {
  const [msg, setMsg] = useState("");
  const tap = async (pet, kind, id, verb, again = false) => {
    try { await axios.post(`${api}/pets/${pet.id}/${kind}/${id}/${verb}`, { again }, { headers: { "X-Sitter-Session": session } }); setMsg(""); reload(); } catch (e) {
      const det = e.response?.data?.detail;
      if (e.response?.status === 409 && window.confirm(det?.message || "Already done. Again?")) tap(pet, kind, id, verb, true); else if (e.response?.status !== 409) setMsg("Couldn't save that. Try again.");
    }
  };
  return (
    <>
      {d.pets.map((p) => (
        <section key={p.id} className="q-card space-y-3" data-testid={`sitter-pet-${p.name}`}>
          <div className="flex items-center gap-3">
            {p.has_photo ? <Photo url={`${api}/pets/${p.id}/photo`} session={session} alt={p.name} /> : <Photo url="" session={session} alt="" />}
            <div className="min-w-0"><h2 className="font-display text-xl font-extrabold">{p.name}</h2><p className="text-sm text-q-muted">{[p.species, p.breed].filter(Boolean).join(" · ")}</p></div>
          </div>
          {p.quirks && <p className="text-sm" data-testid={`sitter-pet-quirks-${p.name}`}><b>Quirks:</b> {p.quirks}</p>}
          <div><p className="q-label">Feeding</p><ul>{p.meals.map((m) => <Check key={m.id} label={`${m.time_label} · ${m.food}${m.amount ? ` (${m.amount})` : ""}`} done={m.done} canFeed={d.can_feed} verb="Fed" onTap={() => tap(p, "meals", m.id, "fed")} testid={`sitter-meal-${m.id}`} />)}</ul></div>
          {p.meds.length > 0 && <div><p className="q-label">Medications</p><ul>{p.meds.flatMap((m) => m.slots.map((s) => <Check key={s.id} label={`${m.name} · ${m.dose} · ${s.time_label}`} done={s.done} canFeed={d.can_feed} verb="Given" onTap={() => tap(p, "meds", s.id, "given")} testid={`sitter-med-${s.id.replace("@", "-")}`} />))}</ul></div>}
          {p.vet_clinic && <p className="flex flex-wrap items-center gap-2 text-sm" data-testid={`sitter-pet-vet-${p.name}`}><b>Vet:</b> {p.vet_clinic} {p.vet_phone && <Tel phone={p.vet_phone} testid={`sitter-pet-vet-phone-${p.name}`} />}</p>}
          {p.microchip && <p className="text-sm" data-testid={`sitter-pet-chip-${p.name}`}><b>Microchip:</b> {p.microchip}{p.registry ? ` (${p.registry})` : ""}</p>}
        </section>
      ))}
      {msg && <p className="q-error">{msg}</p>}
    </>
  );
}
